
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("89CKS", function(module, exports) {
/**
 * @generated SignedSource<<fcddcf783b4b8317e3322bb502f8e37b>>
 * @relayHash 1c39b72e16854d19d11c51ceef0122b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 57a186e10000ef184bec3a0e71a8dec9c1b57a66702d145178c98368d5d78434
const $76fac522acc3b282$var$node = function() {
    var v0 = [
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ExternalCollaboratorFeature",
                    "kind": "LinkedField",
                    "name": "externalCollaborator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "fetchMentionsProviderDataQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "fetchMentionsProviderDataQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "1c39b72e16854d19d11c51ceef0122b1",
            "id": "57a186e10000ef184bec3a0e71a8dec9c1b57a66702d145178c98368d5d78434",
            "metadata": {},
            "name": "fetchMentionsProviderDataQuery",
            "operationKind": "query",
            "text": "query fetchMentionsProviderDataQuery{entitlements{externalCollaborator{isEntitled}}}"
        }
    };
}();
$76fac522acc3b282$var$node.hash = "97f5ab279ca8162d7d39b760a9aa8808";
var $76fac522acc3b282$export$2e2bcd8739ae039 = $76fac522acc3b282$var$node;
module.exports["default"] = $76fac522acc3b282$export$2e2bcd8739ae039;

});

parcelRegister("dtVue", function(module, exports) {

var $jubk3 = parcelRequire("jubk3");

function $c25f711fd5cdf3ef$export$72aeabfc882e7732(cloudId, accountId, mentionContext, withAnalyticsEventProps, onInviteItemClick, userRole, isEligibleXProductUserInvite, onXProductUserInviteClick) {
    return (0, $jubk3.getMentionsConfig)(cloudId, accountId, mentionContext, withAnalyticsEventProps, onInviteItemClick, userRole, isEligibleXProductUserInvite, onXProductUserInviteClick);
}
module.exports["createMentionsConfig"] = $c25f711fd5cdf3ef$export$72aeabfc882e7732;

});

parcelRegister("jubk3", function(module, exports) {

var $kN1ON = parcelRequire("kN1ON");

var $ly0vw = parcelRequire("ly0vw");


var $7lu50 = parcelRequire("7lu50");


var $f7B1p = parcelRequire("f7B1p");


var $04e9M = parcelRequire("04e9M");


var $46J5o = parcelRequire("46J5o");


var $80Dol = parcelRequire("80Dol");


var $g2yI6 = parcelRequire("g2yI6");

const $b08c9dc0f73ff25f$export$7758cc57d736bc3e = '/gateway/api/mentions';
const $b08c9dc0f73ff25f$export$bcbcd41d6c96b319 = '/gateway/api/teams/mentions';
const $b08c9dc0f73ff25f$var$X_PRODUCT_USER_INVITE_URL = '/gateway/api/v3/invitations/invite';
async function $b08c9dc0f73ff25f$export$395a616bfa7556a6(cloudId, spaceId, accountId, withAnalyticsEventProps, onInviteItemClick, userRole, focusedMentionId, isEligibleXProductUserInvite, onXProductUserInviteClick) {
    const userMentionConfig = {
        url: `${$b08c9dc0f73ff25f$export$7758cc57d736bc3e}/${cloudId}`,
        productId: 'micros-group/confluence',
        containerId: spaceId || undefined,
        shouldHighlightMention: (mention)=>mention.id === accountId,
        debounceTime: 150
    };
    const shouldEnableInvite = !!onInviteItemClick;
    if (shouldEnableInvite) {
        userMentionConfig.productName = 'Confluence';
        userMentionConfig.shouldEnableInvite = shouldEnableInvite;
        userMentionConfig.onInviteItemClick = onInviteItemClick;
        userMentionConfig.userRole = userRole;
    }
    userMentionConfig.inviteXProductUser = async (userId, mentionName)=>{
        let isSuccess = false;
        let client;
        try {
            if (accountId === userId || isEligibleXProductUserInvite && !await isEligibleXProductUserInvite()) return;
            client = await (0, $04e9M.getAnalyticsWebClient)();
            const response = await (0, $f7B1p.cfetch)($b08c9dc0f73ff25f$var$X_PRODUCT_USER_INVITE_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    users: [
                        {
                            id: userId
                        }
                    ],
                    resources: [
                        `ari:cloud:confluence::site/${cloudId}`
                    ]
                })
            });
            if (!response.ok) throw new Error(`Network response error.  HTTP status: ${response.status}`);
            const data = await response.json();
            const inviteResponseObj = data[0];
            const product = Object.keys(inviteResponseObj?.results || {})[0];
            const invitationStatus = inviteResponseObj?.results?.[product];
            isSuccess = product?.includes('confluence') && invitationStatus === 'INVITED';
            await client.sendTrackEvent({
                source: 'editor',
                action: 'invited',
                actionSubject: 'xProductUser',
                attributes: {
                    invitationStatus: invitationStatus,
                    inviteeId: userId
                }
            });
        } catch (error) {
            client = await (0, $04e9M.getAnalyticsWebClient)();
            const errorMessages = error instanceof Error ? error.message : String(error);
            client.sendOperationalEvent({
                source: 'editor',
                action: 'errored',
                actionSubject: 'xProductUserInvite',
                attributes: {
                    error: errorMessages,
                    stack: error?.stack,
                    inviteeId: userId
                }
            });
            isSuccess = false;
        }
        onXProductUserInviteClick?.(mentionName, isSuccess);
    };
    const teamMentionConfig = {
        url: $b08c9dc0f73ff25f$export$bcbcd41d6c96b319,
        productId: 'micros-group/confluence',
        shouldHighlightMention: (mention)=>mention.id === accountId
    };
    const scrollToMention = ()=>{
        if (focusedMentionId) {
            const mentionElement = document.querySelector(`[data-local-id="${focusedMentionId}"]`);
            if (mentionElement) mentionElement.scrollIntoView({
                behavior: 'instant',
                inline: 'center',
                block: 'center'
            });
        }
    };
    userMentionConfig.mentionNameResolver = new (0, $kN1ON.DefaultMentionNameResolver)(new (0, $46J5o.MentionNameClient)(), withAnalyticsEventProps, scrollToMention);
    return $b08c9dc0f73ff25f$var$userTeamMentionProvider(userMentionConfig, teamMentionConfig, isEligibleXProductUserInvite);
}
async function $b08c9dc0f73ff25f$var$userTeamMentionProvider(userMentionConfig, teamMentionConfig, isEligibleXProductUserInvite) {
    let includeExternalCollaborators = false;
    const data = await (0, $g2yI6.fetchMentionsProviderData)();
    // Entitlement check to determine if tenant is premium/enabled for Guests
    includeExternalCollaborators = data ? (0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(data) === true : false;
    return new (0, $80Dol.UserTeamMentionProvider)('/gateway/api/v1/recommendations', userMentionConfig, teamMentionConfig, includeExternalCollaborators, isEligibleXProductUserInvite);
}
async function $b08c9dc0f73ff25f$export$86c3c7f166be321d(cloudId, accountId, mentionContext, withAnalyticsEventProps, onInviteItemClick, userRole, isEligibleXProductUserInvite, onXProductUserInviteClick) {
    if (!cloudId) throw new Error('MentionResource cannot be configured without a cloud id');
    const spaceId = mentionContext?.spaceId || undefined;
    const mentionResource = await $b08c9dc0f73ff25f$export$395a616bfa7556a6(cloudId, spaceId, accountId, withAnalyticsEventProps, onInviteItemClick, userRole, undefined, isEligibleXProductUserInvite, onXProductUserInviteClick);
    return {
        mentionResource: mentionResource,
        presenceResource: new (0, $ly0vw.default)({
            url: '/gateway/api/directory/graphql',
            cloudId: cloudId,
            productId: 'confluence'
        }),
        // Required for the TinyMCE mentions plugin, should be removed when TinyMCE is removed
        mentionServiceUrl: `${$b08c9dc0f73ff25f$export$7758cc57d736bc3e}/${cloudId}`,
        contextIdentifier: {
            containerId: spaceId || '',
            objectId: mentionContext?.contentId || '',
            childObjectId: mentionContext?.commentId || ''
        }
    };
}
module.exports["createFabricMentionResource"] = $b08c9dc0f73ff25f$export$395a616bfa7556a6;
module.exports["getMentionsConfig"] = $b08c9dc0f73ff25f$export$86c3c7f166be321d;

});

parcelRegister("kN1ON", function(module, exports) {

var $6mYMS = parcelRequire("6mYMS");


var $3jsXx = parcelRequire("3jsXx");

class $68b29c117af189b3$export$2ae0434dccdcb77e {
    lookupName(id) {
        const name = this.nameCache.get(id);
        if (name) {
            this.fireAnalytics(true, name);
            if (this.nameQueue.size === 0) this.scheduleOnAllResolved();
            return name;
        }
        return new Promise((resolve)=>{
            const processingItems = this.processingQueue.get(id);
            if (processingItems) this.processingQueue.set(id, [
                ...processingItems,
                resolve
            ]);
            const queuedItems = this.nameQueue.get(id) || [];
            this.nameQueue.set(id, [
                ...queuedItems,
                resolve
            ]);
            if (queuedItems.length === 0 && !processingItems) this.nameStartTime.set(id, Date.now());
            this.scheduleProcessQueue();
            if (this.isQueueAtLimit()) this.processQueue();
        });
    }
    cacheName(id, name) {
        this.nameCache.set(id, {
            id: id,
            name: name,
            status: (0, $6mYMS.MentionNameStatus).OK
        });
    }
    scheduleProcessQueue() {
        if (!this.debounce) this.debounce = window.setTimeout(this.processQueue, $68b29c117af189b3$export$2ae0434dccdcb77e.waitForBatch);
    }
    scheduleOnAllResolved() {
        if (this.debounceOnResolve) clearTimeout(this.debounceOnResolve);
        this.debounceOnResolve = window.setTimeout(()=>{
            if (this.isOnResolvedAllCalled) return;
            this.onResolvedAll();
            this.isOnResolvedAllCalled = true;
        }, $68b29c117af189b3$export$2ae0434dccdcb77e.waitForResolveAll);
    }
    isQueueAtLimit() {
        return this.nameQueue.size >= this.client.getLookupLimit();
    }
    splitQueueAtLimit() {
        const values = Array.from(this.nameQueue.entries());
        const splitPoint = this.client.getLookupLimit();
        return {
            queue: new Map(values.slice(0, splitPoint)),
            extraQueue: new Map(values.slice(splitPoint))
        };
    }
    resolveQueueItem(mentionDetail) {
        const { id: id } = mentionDetail;
        const resolvers = this.processingQueue.get(id);
        if (resolvers) {
            this.processingQueue.delete(id);
            this.nameCache.set(id, mentionDetail);
            resolvers.forEach((resolve)=>{
                try {
                    resolve(mentionDetail);
                } catch  {
                // ignore - exception in consumer
                }
            });
            this.fireAnalytics(false, mentionDetail);
        }
    }
    fireAnalytics(fromCache, mentionDetail) {
        const { id: id } = mentionDetail;
        const action = mentionDetail.status === (0, $6mYMS.MentionNameStatus).OK ? 'completed' : 'failed';
        const start = this.nameStartTime.get(id);
        const duration = start ? Date.now() - start : 0;
        this.nameStartTime.delete(id);
        this.fireHydrationEvent(action, id, fromCache, duration);
    }
    constructor(client, analyticsProps = {}, onResolvedAll = ()=>{}){
        // ms
        this.client = void 0;
        this.nameCache = new Map();
        this.nameQueue = new Map();
        this.nameStartTime = new Map();
        this.processingQueue = new Map();
        this.debounce = 0;
        this.debounceOnResolve = null;
        this.onResolvedAll = void 0;
        this.isOnResolvedAllCalled = false;
        this.fireHydrationEvent = void 0;
        this.processQueue = ()=>{
            clearTimeout(this.debounce);
            this.debounce = 0;
            const { queue: queue, extraQueue: extraQueue } = this.splitQueueAtLimit();
            this.nameQueue = extraQueue;
            this.processingQueue = $68b29c117af189b3$export$71ea0798a8cad7d8(this.processingQueue, queue);
            this.client.lookupMentionNames(Array.from(queue.keys())).then((response)=>{
                response.forEach((mentionDetail)=>{
                    const { id: id } = mentionDetail;
                    queue.delete(id);
                    this.resolveQueueItem(mentionDetail);
                });
                queue.forEach((_callback, id)=>{
                    // No response from client for these ids treat as unknown
                    this.resolveQueueItem({
                        id: id,
                        status: (0, $6mYMS.MentionNameStatus).UNKNOWN
                    });
                });
            }).catch(()=>{
                // Service completely failed, reject all items in the queue
                queue.forEach((_callback, id)=>{
                    this.resolveQueueItem({
                        id: id,
                        status: (0, $6mYMS.MentionNameStatus).SERVICE_ERROR
                    });
                });
            });
            // Make sure anything left in the queue gets processed.
            if (this.nameQueue.size > 0) this.scheduleProcessQueue();
            else this.scheduleOnAllResolved();
        };
        this.client = client;
        this.fireHydrationEvent = (0, $3jsXx.fireAnalyticsMentionHydrationEvent)(analyticsProps);
        // If provided, this will be called once all pending mentions in the queue are resolved.
        // A sample usage is scrolling to a mention on page load, after the mentions have loadad.
        this.onResolvedAll = onResolvedAll;
    }
}
/**
 * Merge the two queues making sure to merge callback arrays for items in queueB already in queueA.
 * This addresses [this ticket](https://product-fabric.atlassian.net/browse/QS-3789).
 */ $68b29c117af189b3$export$2ae0434dccdcb77e.waitForBatch = 100;
// ms
$68b29c117af189b3$export$2ae0434dccdcb77e.waitForResolveAll = 800;
function $68b29c117af189b3$export$71ea0798a8cad7d8(queueA, queueB) {
    const queueBeingMerged = new Map([
        ...queueA
    ]);
    // now add the items from the second queue that are not already in the
    //  merged queue being built
    [
        ...queueB
    ].forEach((item)=>{
        const [key, queueBCallbacks] = item;
        const itemAlreadyInMergedQueue = queueBeingMerged.has(key);
        if (!itemAlreadyInMergedQueue) queueBeingMerged.set(key, queueBCallbacks);
        else {
            // item already in merged queue, merge the callback arrays
            const queueACallbacks = queueBeingMerged.get(key) ?? [];
            const mergedCallbacks = new Set([
                ...queueBCallbacks,
                ...queueACallbacks
            ]);
            const deduplicatedCallbacks = Array.from(mergedCallbacks.values()); // prevents calling them twice
            queueBeingMerged.set(key, deduplicatedCallbacks);
        }
    });
    return queueBeingMerged;
}
module.exports["DefaultMentionNameResolver"] = $68b29c117af189b3$export$2ae0434dccdcb77e;

});

parcelRegister("ly0vw", function(module, exports) {

var $jaPjp = parcelRequire("jaPjp");


var $bqMS3 = parcelRequire("bqMS3");

class $c68c97e41ce8434f$var$CacheEntry {
    expired() {
        return Date.now() > this.expiry;
    }
    constructor(pres, timeout){
        this.presence = void 0;
        this.expiry = void 0;
        this.presence = pres;
        this.expiry = Date.now() + timeout;
    }
}
class $c68c97e41ce8434f$export$7b4524ed61cc8203 extends (0, $bqMS3.AbstractResource) {
    refreshPresence(userIds) {
        throw new Error(`not yet implemented.\nParams: userIds=${userIds}`);
    }
    notifyListeners(presences) {
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(presences);
            } catch (e) {
                // ignore error from listener
                (0, $jaPjp.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $c68c97e41ce8434f$var$PresenceResource extends $c68c97e41ce8434f$export$7b4524ed61cc8203 {
    refreshPresence(userIds) {
        const cacheHits = this.presenceCache.getBulk(userIds);
        this.notifyListeners(cacheHits);
        const cacheMisses = this.presenceCache.getMissingUserIds(userIds);
        if (cacheMisses.length) this.retrievePresence(cacheMisses);
    }
    retrievePresence(userIds) {
        this.queryDirectoryForPresences(userIds).then((res)=>this.presenceParser.parse(res)).then((presences)=>{
            this.notifyListeners(presences);
            this.presenceCache.update(presences);
        });
    }
    queryDirectoryForPresences(userIds) {
        const query = {
            query: `query getPresenceForMentions($organizationId: String!, $userIds: [String!], $productId: String) {
                PresenceBulk(organizationId: $organizationId, product: $productId, userIds: $userIds) {
                  userId
                  state
                  stateMetadata
                }
              }`,
            variables: {
                organizationId: this.config.cloudId,
                userIds: userIds
            }
        };
        if (this.config.productId) query.variables['productId'] = this.config.productId;
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(query)
        };
        return fetch(this.config.url, options).then((response)=>response.json());
    }
    static cleanUrl(url) {
        if (url.substr(-1) !== '/') url += '/';
        return url;
    }
    constructor(config){
        super();
        this.config = void 0;
        this.presenceCache = void 0;
        this.presenceParser = void 0;
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.cloudId) throw new Error('config.cloudId is a required parameter');
        this.config = config;
        this.config.url = $c68c97e41ce8434f$var$PresenceResource.cleanUrl(config.url);
        this.presenceCache = config.cache || new $c68c97e41ce8434f$export$f962b6f1aaaafaf5(config.cacheExpiry);
        this.presenceParser = config.parser || new $c68c97e41ce8434f$export$80bae4549cafd20d();
    }
}
class $c68c97e41ce8434f$export$f962b6f1aaaafaf5 {
    /**
   * Precondition: _delete is only called internally if userId exists in cache
   * Removes cache entry
   * @param userId
   */ _delete(userId) {
        delete this.cache[userId];
        this.size--;
    }
    /**
   * Checks a cache entry and calls delete if the info has expired
   * @param userId
   */ _deleteIfExpired(userId) {
        if (this.contains(userId) && this.cache[userId].expired()) this._delete(userId);
    }
    /**
   * Cleans expired entries from cache
   */ _removeExpired() {
        Object.keys(this.cache).forEach((id)=>{
            this._deleteIfExpired(id);
        });
    }
    /**
   * Checks if a user exists in the cache
   * @param userId
   */ contains(userId) {
        return this.cache.hasOwnProperty(userId);
    }
    /**
   * Retrieves a presence from the cache after checking for expired entries
   * @param userId - to index the cache
   * @returns Presence - the presence that matches the userId
   */ get(userId) {
        this._deleteIfExpired(userId);
        if (!this.contains(userId)) return {};
        return this.cache[userId].presence;
    }
    /**
   * Retrieve multiple presences at once from the cache
   * @param userIds - to index the cache
   * @returns PresenceMap - A map of userIds to cached Presences
   */ getBulk(userIds) {
        const presences = {};
        for (const userId of userIds)if (this.contains(userId)) presences[userId] = this.get(userId);
        return presences;
    }
    /**
   * For a given list of ids, returns a subset
   * of all the ids with missing cache entries.
   * @param userIds - to index the cache
   * @returns string[] - ids missing from the cache
   */ getMissingUserIds(userIds) {
        return userIds.filter((id)=>!this.contains(id));
    }
    /**
   * Precondition: presMap only contains ids of users not in cache
   *               expired users must first be removed then reinserted with updated presence
   * Updates the cache by adding the new Presence entries and setting the expiry time
   * @param presMap
   */ update(presMap) {
        if (this.size >= this.flushTrigger) this._removeExpired();
        Object.keys(presMap).forEach((userId)=>{
            this.cache[userId] = new $c68c97e41ce8434f$var$CacheEntry(presMap[userId], this.expiryInMillis);
            this.size++;
        });
    }
    constructor(cacheTimeout, cacheTrigger){
        this.cache = void 0;
        this.size = void 0;
        this.expiryInMillis = void 0;
        this.flushTrigger = void 0;
        this.expiryInMillis = cacheTimeout ? cacheTimeout : $c68c97e41ce8434f$export$f962b6f1aaaafaf5.defaultTimeout;
        this.flushTrigger = cacheTrigger ? cacheTrigger : $c68c97e41ce8434f$export$f962b6f1aaaafaf5.defaultFlushTrigger;
        this.cache = {};
        this.size = 0;
    }
}
$c68c97e41ce8434f$export$f962b6f1aaaafaf5.defaultTimeout = 20000;
$c68c97e41ce8434f$export$f962b6f1aaaafaf5.defaultFlushTrigger = 50;
class $c68c97e41ce8434f$export$80bae4549cafd20d {
    mapState(state) {
        if (state === 'unavailable') return 'offline';
        else if (state === 'available') return 'online';
        else return state;
    }
    parse(response) {
        const presences = {};
        if (response.hasOwnProperty('data') && response['data'].hasOwnProperty('PresenceBulk')) {
            const results = response['data'].PresenceBulk;
            // Store map of state and time indexed by userId.  Ignore null results.
            for (const user of results){
                if (user.userId && user.state) {
                    const state = $c68c97e41ce8434f$export$80bae4549cafd20d.extractState(user) || user.state;
                    presences[user.userId] = {
                        status: this.mapState(state)
                    };
                } else if (!user.hasOwnProperty('userId') || !user.hasOwnProperty('state')) // eslint-disable-next-line no-console
                console.error('Unexpected response from presence service contains keys: ' + Object.keys(user));
            }
        }
        return presences;
    }
    static extractState(presence) {
        if ($c68c97e41ce8434f$export$80bae4549cafd20d.isFocusState(presence)) return $c68c97e41ce8434f$export$80bae4549cafd20d.FOCUS_STATE;
        return presence.state;
    }
    /*
     This is a bit of an odd exception. In the case where a user is in "Focus Mode", their presence state
     is returned as 'busy' along with a `stateMetadata` object containing a `focus` field.
     In this case we ignore the value of the `state` field and treat the presence as a 'focus' state.
    */ static isFocusState(presence) {
        if (presence.stateMetadata) try {
            const metadata = JSON.parse(presence.stateMetadata);
            return metadata && !!metadata.focus;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`Failed to parse presence's stateMetadata for user with id ${presence.userId}: ${presence.stateMetadata}`);
            // eslint-disable-next-line no-console
            console.error(e);
        }
        return false;
    }
}
$c68c97e41ce8434f$export$80bae4549cafd20d.FOCUS_STATE = 'focus';
var $c68c97e41ce8434f$export$2e2bcd8739ae039 = $c68c97e41ce8434f$var$PresenceResource;
module.exports["default"] = $c68c97e41ce8434f$export$2e2bcd8739ae039;

});

parcelRegister("46J5o", function(module, exports) {

var $6mYMS = parcelRequire("6mYMS");


var $k1vn7 = parcelRequire("k1vn7");

class $71c2faaa98a432d0$export$82da878d725997a7 {
    getLookupLimit() {
        // HOT-108964 - sending too many mentions in the request header at once returns a 400
        // The API itself apparently has a hard limit of 90 (HOT-95106), but if we're not careful we can send too many
        // mentions and make the request header too large and the endpoint falls over
        return 0, $k1vn7.MENTIONS_LOOKUP_LIMIT;
    }
    async lookupMentionNames(ids) {
        // Allows to rely upon the preloaded mentions data when resolving mentions in the editor
        // both on the client and server side
        return (0, $k1vn7.preloadMentionsUsers)(ids).then((users)=>users.map((user)=>({
                    ...user,
                    status: (0, $6mYMS.MentionNameStatus).OK
                })));
    }
}
module.exports["MentionNameClient"] = $71c2faaa98a432d0$export$82da878d725997a7;

});

parcelRegister("k1vn7", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $1ZEfa = parcelRequire("1ZEfa");


var $dYU3e = parcelRequire("dYU3e");

const $ed0e2cb9f5186ade$var$ARI_PREFIX = 'ari:cloud:identity::user/';
const $ed0e2cb9f5186ade$export$7c5848ab9f90077b = 50;
const $ed0e2cb9f5186ade$var$PreloadMentionsUsersUsersQuery = (0, $1ZEfa.default);
const $ed0e2cb9f5186ade$var$getUserData = async (ids)=>{
    const { data: data } = await (async ()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult = await (0, $dYU3e.queryAgg)({
            query: $ed0e2cb9f5186ade$var$PreloadMentionsUsersUsersQuery,
            variables: {
                ids: ids
            }
        });
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
        return _asyncResult;
    })();
    return data?.users;
};
const $ed0e2cb9f5186ade$export$3adfff745266e959 = async (userIds)=>{
    const ids = userIds.map((id)=>`${$ed0e2cb9f5186ade$var$ARI_PREFIX}${id}`);
    const users = await (async ()=>{
        const _beforeResult2 = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult2 = await $ed0e2cb9f5186ade$var$getUserData(ids);
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
        return _asyncResult2;
    })();
    return (users || []).map((user)=>({
            id: user?.id?.replace($ed0e2cb9f5186ade$var$ARI_PREFIX, ''),
            name: user?.name
        }));
};
module.exports["MENTIONS_LOOKUP_LIMIT"] = $ed0e2cb9f5186ade$export$7c5848ab9f90077b;
module.exports["preloadMentionsUsers"] = $ed0e2cb9f5186ade$export$3adfff745266e959;

});

parcelRegister("1ZEfa", function(module, exports) {
/**
 * @generated SignedSource<<59554e5c48b23248e96fbd4f6208bc53>>
 * @relayHash f1566d2dfc3b1c8e62dbd552d1d5ea7b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9462e63394baf36280594937ebc20a422e66d58c766cd5505aac94789185200f
const $2c3903aefb77a74c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ids"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "ids"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadMentionsUsersUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadMentionsUsersUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "f1566d2dfc3b1c8e62dbd552d1d5ea7b",
            "id": "9462e63394baf36280594937ebc20a422e66d58c766cd5505aac94789185200f",
            "metadata": {},
            "name": "preloadMentionsUsersUsersQuery",
            "operationKind": "query",
            "text": "query preloadMentionsUsersUsersQuery($ids:[ID!]!){users(accountIds:$ids){__typename,id,name}}"
        }
    };
}();
$2c3903aefb77a74c$var$node.hash = "3783fdf735e372b90adc93c9f8ad8005";
var $2c3903aefb77a74c$export$2e2bcd8739ae039 = $2c3903aefb77a74c$var$node;
module.exports["default"] = $2c3903aefb77a74c$export$2e2bcd8739ae039;

});

parcelRegister("80Dol", function(module, exports) {

var $bqMS3 = parcelRequire("bqMS3");


var $3jsXx = parcelRequire("3jsXx");


var $6mYMS = parcelRequire("6mYMS");


var $f7B1p = parcelRequire("f7B1p");


var $ge2sX = parcelRequire("ge2sX");


var $9fywD = parcelRequire("9fywD");


var $04e9M = parcelRequire("04e9M");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $5CrKL = parcelRequire("5CrKL");


var $j5rtD = parcelRequire("j5rtD");

const $76cb501321125a14$var$INITIAL_STATE = 'initialState';
const $76cb501321125a14$var$SEARCH = 'searchUser';
const $76cb501321125a14$var$SUCCEEDED = 'succeeded';
const $76cb501321125a14$var$FAILED = 'failed';
const $76cb501321125a14$var$CONTEXT_TYPE = 'Mentions';
const $76cb501321125a14$var$MAX_RESULTS = 20;
// Use in memory cache only
const $76cb501321125a14$var$defaultCache = {
    getStoredValues: ()=>Promise.resolve(new Map()),
    setStoredValues: ()=>Promise.resolve()
};
class $76cb501321125a14$export$f500b4849378edff extends (0, $bqMS3.default) {
    /**
   * Overrides `remoteInitialState` from `MentionResource`
   * This is invoked for bootstrap/empty queries,
   */ async remoteInitialState(contextIdentifier) {
        try {
            const promise = await this.doSearch('', contextIdentifier);
            // Set initial cache
            if ((0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true)) this.offlineCache?.set(this.userTeamEndpoint, promise);
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), $76cb501321125a14$var$INITIAL_STATE, $76cb501321125a14$var$SUCCEEDED);
            return promise;
        } catch (e) {
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), $76cb501321125a14$var$INITIAL_STATE, $76cb501321125a14$var$FAILED);
            throw e;
        }
    }
    /**
   * Overrides `remoteSearch` from `MentionResource`
   * This is invoked for non-empty queries.
   */ async remoteSearch(query, contextIdentifier) {
        try {
            const promise = await this.doSearch(query, contextIdentifier);
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), $76cb501321125a14$var$SEARCH, $76cb501321125a14$var$SUCCEEDED);
            return promise;
        } catch (e) {
            this._notifyAnalyticsListeners((0, $3jsXx.SLI_EVENT_TYPE), $76cb501321125a14$var$SEARCH, $76cb501321125a14$var$FAILED);
            throw e;
        }
    }
    async getCachedValue(query) {
        const cachedValue = this.offlineCache?.get(this.userTeamEndpoint);
        if (!cachedValue) return undefined;
        if (query === '') return Promise.resolve(cachedValue);
        else {
            // If we're offline allow basic filtering of the cached results by name.
            if (window?.navigator.onLine === false) return Promise.resolve({
                query: query,
                mentions: cachedValue.mentions?.filter((v)=>v?.name?.toLowerCase().includes(query.toLowerCase()) || v?.mentionName?.toLowerCase().includes(query.toLowerCase()) || v?.nickname?.toLowerCase().includes(query.toLowerCase()))
            });
        }
    }
    async doSearch(query, contextIdentifier) {
        if ((0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true)) {
            const cachedValue = await this.getCachedValue(query);
            // Use stale-while-revalidate - if the cached value exists use it first and
            // update the cache value in the background so that it's up to date when the
            // next call is made
            if (cachedValue) {
                if (query === '') this.doNetworkSearch(query, contextIdentifier).then((results)=>{
                    this.offlineCache?.set(this.userTeamEndpoint, results);
                }).catch(()=>{
                // Pass, it's okay if the cache doesn't update
                });
                return cachedValue;
            }
            return this.doNetworkSearch(query, contextIdentifier);
        } else return this.doNetworkSearch(query, contextIdentifier);
    }
    async doNetworkSearch(query, contextIdentifier) {
        (0, $5CrKL.MENTIONS_QUERY_METRIC).start();
        const response = await this.post(await this.cloudId(), await this.orgId(), query, contextIdentifier);
        if (!response.ok) {
            const errorBody = await response.json();
            (0, $5CrKL.MENTIONS_QUERY_METRIC).stop({
                customData: {
                    isExCoEnabled: this.includeExternalCollaborators,
                    success: false
                }
            });
            throw new Error(JSON.stringify(errorBody));
        }
        const body = await response.json();
        const mentions = body.recommendedUsers.map((recommended)=>{
            if (this.isUser(recommended)) return this.convertToUserMention(recommended);
            else this.isTeam(recommended);
            return this.convertToTeamMention(recommended);
        });
        let jiraMentions = [];
        if (mentions.length < $76cb501321125a14$var$MAX_RESULTS && this.isEligibleXProductUserInvite && await this.isEligibleXProductUserInvite()) try {
            const jiraResponse = await this.searchXproductUsers(await this.cloudId(), await this.orgId(), query, contextIdentifier);
            if (!jiraResponse.ok) {
                const errorBody = await jiraResponse.json();
                throw new Error(JSON.stringify(errorBody));
            }
            const jiraBody = await jiraResponse.json();
            // Remove objects from jiraMentions if an object with the same id is present in mentions
            const mentionIds = new Set(mentions.map((mention)=>mention.id));
            const recommendedJiraUsers = (jiraBody.recommendedUsers || []).filter((mention)=>!mentionIds.has(mention?.id)).slice(0, $76cb501321125a14$var$MAX_RESULTS - mentions.length);
            //only evaluate the experiment cohort if there are jira mentions to show
            if (recommendedJiraUsers.length > 0 && (0, $6mKj3.expValEquals)('cc_virality_x_product_user_invite', 'cohort', 'test')) jiraMentions = recommendedJiraUsers.map((recommended)=>{
                return {
                    ...this.convertToUserMention(recommended),
                    isXProductUser: true
                };
            });
        } catch (error) {
            const client = await (0, $04e9M.getAnalyticsWebClient)();
            const errorMessages = error instanceof Error ? error.message : String(error);
            client.sendOperationalEvent({
                source: 'editor',
                action: 'errored',
                actionSubject: 'xProductUserSearch',
                attributes: {
                    error: errorMessages,
                    stack: error?.stack
                }
            });
        }
        (0, $5CrKL.MENTIONS_QUERY_METRIC).stop({
            customData: {
                isExCoEnabled: this.includeExternalCollaborators,
                success: true
            }
        });
        return {
            query: query,
            mentions: [
                ...mentions,
                ...jiraMentions
            ]
        };
    }
    async cloudId() {
        const { cloudId: cloudId } = await (0, $ge2sX.getSessionData)();
        return cloudId;
    }
    async orgId() {
        const { orgId: orgId } = await (0, $ge2sX.getSessionData)();
        return orgId;
    }
    async post(cloudId, orgId, query, contextIdentifier) {
        return await (0, $f7B1p.cfetch)(this.userTeamEndpoint, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                context: {
                    contextType: $76cb501321125a14$var$CONTEXT_TYPE,
                    principalId: 'context',
                    productKey: contextIdentifier && contextIdentifier.product || 'confluence',
                    // defaults to 'confluence' to work with old editor
                    siteId: cloudId,
                    containerId: contextIdentifier && contextIdentifier.containerId,
                    objectId: contextIdentifier && contextIdentifier.objectId,
                    childObjectId: contextIdentifier && contextIdentifier.childObjectId,
                    mentionsSessionId: contextIdentifier && contextIdentifier.sessionId,
                    ...orgId ? {
                        organizationId: orgId
                    } : {},
                    ...this.includeExternalCollaborators ? {
                        productAttributes: {
                            isEntitledConfluenceExternalCollaborator: true
                        }
                    } : {}
                },
                searchQuery: {
                    queryString: query,
                    ...this.includeExternalCollaborators ? {
                        productAccessPermissionIds: [
                            'write',
                            'external-collaborator-write'
                        ]
                    } : {}
                },
                maxNumberOfResults: $76cb501321125a14$var$MAX_RESULTS,
                includeTeams: true
            })
        });
    }
    async searchXproductUsers(cloudId, orgId, query, contextIdentifier) {
        return await (0, $f7B1p.cfetch)(this.userTeamEndpoint, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                context: {
                    contextType: $76cb501321125a14$var$CONTEXT_TYPE,
                    principalId: 'context',
                    productKey: 'jira',
                    // fetch only jira users
                    siteId: cloudId,
                    mentionsSessionId: contextIdentifier && contextIdentifier.sessionId,
                    ...orgId ? {
                        organizationId: orgId
                    } : {}
                },
                searchQuery: {
                    queryString: query,
                    productAccessPermissionIds: [
                        'write'
                    ]
                },
                maxNumberOfResults: $76cb501321125a14$var$MAX_RESULTS,
                includeTeams: false // Do not include teams
            })
        });
    }
    isUser(recommended) {
        return recommended.entityType === 'USER';
    }
    convertToUserMention(recommended) {
        return {
            id: recommended.id,
            name: recommended.name || recommended.nickname || '',
            mentionName: recommended.nickname || '',
            avatarUrl: recommended.avatarUrl,
            accessLevel: recommended.accessLevel,
            userType: recommended.userType,
            ...recommended?.attributes?.isConfluenceExternalCollaborator ? {
                lozenge: (0, $9fywD.ExternalUserLozengeProps)
            } : {}
        };
    }
    isTeam(recommended) {
        return recommended.entityType === 'TEAM';
    }
    convertToTeamMention(recommended) {
        const { teamLinkResolver: teamLinkResolver } = this.teamMentionConfig;
        let teamLink = '';
        const defaultTeamLink = `${window.location.origin}/people/team/${recommended.id}`;
        if (typeof teamLinkResolver === 'function') teamLink = teamLinkResolver(recommended.id);
        return {
            id: recommended.id,
            name: recommended.displayName,
            mentionName: recommended.displayName,
            avatarUrl: recommended.smallAvatarImageUrl,
            accessLevel: (0, $6mYMS.UserAccessLevel)[(0, $6mYMS.UserAccessLevel).CONTAINER],
            userType: (0, $6mYMS.UserType)[(0, $6mYMS.UserType).TEAM],
            context: {
                members: recommended.members,
                includesYou: recommended.includesYou,
                memberCount: recommended.memberCount,
                teamLink: teamLink || defaultTeamLink
            }
        };
    }
    constructor(userTeamEndpoint, userMentionConfig, teamMentionConfig, includeExternalCollaborators, isEligibleXProductUserInvite){
        super(userMentionConfig);
        this.userTeamEndpoint = void 0;
        this.teamMentionConfig = void 0;
        this.includeExternalCollaborators = void 0;
        this.offlineCache = void 0;
        this.isEligibleXProductUserInvite = void 0;
        this.teamMentionConfig = teamMentionConfig;
        this.userTeamEndpoint = userTeamEndpoint;
        this.includeExternalCollaborators = includeExternalCollaborators;
        this.isEligibleXProductUserInvite = isEligibleXProductUserInvite;
        const cache = (0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes') ? $76cb501321125a14$var$defaultCache : undefined;
        this.offlineCache = (0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true) ? new (0, $j5rtD.OfflineCache)(cache) : undefined;
    }
}
module.exports["UserTeamMentionProvider"] = $76cb501321125a14$export$f500b4849378edff;

});

parcelRegister("5CrKL", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $41760797bb45431a$export$59eae628ebf25df4 = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.MENTIONS_QUERY_CUSTOM_KEY)
});
module.exports["MENTIONS_QUERY_METRIC"] = $41760797bb45431a$export$59eae628ebf25df4;

});

parcelRegister("j5rtD", function(module, exports) {

var $fFa3V = parcelRequire("fFa3V");

class $099b8337f3ad112c$export$8904fcd398c673fb {
    update() {
        this.storageManager.setStoredValues(this.map).catch(()=>{
        // Pass, it's okay if this fails
        });
    }
    destroy() {
        this.unloadCleanup();
    }
    get(key) {
        return this.map.get(key);
    }
    set(key, value) {
        this.map.set(key, value);
    }
    constructor(storageManager){
        this.map = new Map();
        this.storageManager = void 0;
        this.unloadCleanup = ()=>{};
        const cacheName = 'editor:offline-network-request-cache';
        this.storageManager = storageManager ?? new $099b8337f3ad112c$var$IndexedDBManager(cacheName);
        this.storageManager.getStoredValues()?.then((v)=>{
            this.map = v;
        }).catch(()=>{
        // If the offline cache is rejected, use the initial empty map
        });
        if (window !== undefined) this.unloadCleanup = (0, $fFa3V.bind)(window, {
            type: 'beforeunload',
            listener: ()=>{
                this.update();
            }
        });
    }
}
/** Storage manager using indexeddb */ class $099b8337f3ad112c$var$IndexedDBManager {
    openDatabase() {
        return new Promise((resolve, reject)=>{
            const request = indexedDB.open(this.cacheName, 2);
            request.onupgradeneeded = (event)=>{
                const db = event.target.result;
                // Clear old results
                if (db.objectStoreNames.contains(this.objectStoreName)) db.deleteObjectStore(this.objectStoreName);
                db.createObjectStore(this.objectStoreName);
            };
            request.onsuccess = ()=>{
                resolve(request.result);
            };
            request.onerror = ()=>{
                reject(request.error);
            };
        });
    }
    // Retrieve a map of values for a store based on a set of keys
    async getAllStoredValues(store, keys) {
        const allValues = [];
        for (const key of keys){
            const valueRequest = store.get(key);
            allValues.push(new Promise((resolve, reject)=>{
                valueRequest.onsuccess = ()=>resolve([
                        key,
                        JSON.parse(valueRequest.result)
                    ]);
                valueRequest.onerror = ()=>reject(valueRequest.error);
            }));
        }
        return new Map(await Promise.all(allValues));
    }
    getStoredValues() {
        return this.dbPromise?.then((db)=>{
            return new Promise((resolve, reject)=>{
                const transaction = db.transaction(this.objectStoreName, 'readonly');
                const store = transaction.objectStore(this.objectStoreName);
                const request = store.getAllKeys();
                request.onsuccess = async ()=>{
                    const keys = request.result;
                    const resultMap = await this.getAllStoredValues(store, keys);
                    resolve(resultMap);
                };
                request.onerror = ()=>{
                    reject(request.error);
                };
            });
        }) ?? Promise.reject();
    }
    setStoredValues(values) {
        return this.dbPromise?.then((db)=>{
            return new Promise((resolve, reject)=>{
                const transaction = db.transaction(this.objectStoreName, 'readwrite');
                const store = transaction.objectStore(this.objectStoreName);
                transaction.oncomplete = ()=>resolve();
                transaction.onerror = ()=>reject(transaction.error);
                if (values.size === 0) return;
                // Clear the existing entries before setting new values
                store.clear().onsuccess = ()=>{
                    values.forEach((value, key)=>{
                        const serialisedValue = $099b8337f3ad112c$export$ad730aacbc246ec2(value);
                        if (serialisedValue !== null) store.put(serialisedValue, key);
                    });
                };
            });
        }) ?? Promise.reject();
    }
    constructor(cacheName){
        this.cacheName = cacheName;
        this.dbPromise = undefined;
        this.objectStoreName = 'cache';
        if (window?.indexedDB) this.dbPromise = this.openDatabase();
    }
}
function $099b8337f3ad112c$export$ad730aacbc246ec2(obj) {
    try {
        return JSON.stringify(obj, (_key, value)=>{
            if (typeof value !== 'string' && typeof value !== 'number' && typeof value !== 'boolean' && value !== null && value !== undefined && typeof value !== 'object' && !Array.isArray(value)) throw new Error('Non-serializable property found');
            return value;
        });
    } catch (error) {
        return null;
    }
}
module.exports["OfflineCache"] = $099b8337f3ad112c$export$8904fcd398c673fb;

});

parcelRegister("g2yI6", function(module, exports) {

var $89CKS = parcelRequire("89CKS");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $28b5c5efee4d19cf$var$fetchMentionsProviderDataQuery = (0, $89CKS.default);
const $28b5c5efee4d19cf$export$5ced7267a5286f97 = async ()=>{
    return (0, $c0rhi.queryInterop)({
        query: $28b5c5efee4d19cf$var$fetchMentionsProviderDataQuery
    }).then(({ data: data })=>{
        return data;
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
module.exports["fetchMentionsProviderData"] = $28b5c5efee4d19cf$export$5ced7267a5286f97;

});


//# sourceMappingURL=CommentsPanelFilterMenu.18d2147d.js.map
